import type { Merge } from 'type-fest'

export const MockModel = <Model extends object>(
  defaults: <Overrides extends Partial<Model>>(overrides: Overrides) => Model
) => {
  return <Overrides extends Partial<Model>>(
    overrides: Overrides
  ): Merge<Model, Overrides> => ({ ...defaults(overrides), ...overrides })
}
